import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import DefaultChip from "components/Utils/DefaultChip";
import {PatientImage} from "components/Common/UserImage";
import PatientUtils from "services/PatientUtils";
import {useAppSelector} from "careand-redux/store";
import {useAppDispatch} from "careand-redux/useAppDispatch";
import {api} from "careand-redux/api/ApiThunks";

const PatientChip = ({patient, onClick, id, short = true}) => {

  const dispatch = useAppDispatch();
  const patients = useAppSelector(state => state.patients.byId);
  const [currentPatient, setCurrentPatient] = useState(patient || (id ? patients[id] : undefined));

  useEffect(() => {
    if (!!id && !currentPatient) {
      dispatch(api.Patients.getPatient({id})).then(patient => {
        if (patient) {
          setCurrentPatient(patient);
        }
      })
    }
  }, [dispatch, id, currentPatient]);

  useEffect(() => {
    if (patient) {
      setCurrentPatient(patient);
    }
  }, [patient]);

  return (
    <DefaultChip
      onClick={() => onClick(currentPatient)}
      element={
        <div className="row">
          <PatientImage patient={currentPatient} size={15}/>
          &nbsp;
          {short ? PatientUtils.getShortName(currentPatient) : PatientUtils.getName(currentPatient)}
        </div>
      }
    />
  );
};

PatientChip.propTypes = {
  id: PropTypes.string,
  patient: PropTypes.object,
  onClick: PropTypes.func
};

export default PatientChip;
